<template>
  <div>
    <SModalPortalTo is-confirm-modal-description>
      <p data-cy="decline-description-1">
        {{ $t(`ui.content_move.decline_modal.${isChannelOfCurrentSchoolYear ? 'new_group' : 'old_group'}.description_1`) }}
      </p>
      <p data-cy="decline-description-2">
        {{ $t(`ui.content_move.decline_modal.${isChannelOfCurrentSchoolYear ? 'new_group' : 'old_group'}.description_2`) }}
      </p>
    </SModalPortalTo>

    <SModalPortalTo>
      <div class="d-flex flex-column">
        <b-button block
                  size="lg"
                  variant="link"
                  data-cy="content-move-cancel"
                  @click="$emit('close')"
        >
          {{ $t('ui.content_move.decline_modal.cancel') }}
        </b-button>
        <!-- eslint-disable-next-line sdui/require-focus-restore-on-disabled-button -->
        <b-button
          block
          size="lg"
          variant="primary"
          data-cy="content-move-decline"
          :class="{ 'spinner-btn': $wait.waiting('decline-content-move') }"
          :disabled="$wait.waiting('decline-content-move')"
          @click="$emit('decline-content-move')"
        >
          {{ $t(`ui.content_move.decline_modal.${isChannelOfCurrentSchoolYear ? 'new_group' : 'old_group'}.confirm`) }}
        </b-button>
      </div>
    </SModalPortalTo>
  </div>
</template>

<script>
import SModalPortalTo from 'src/components/base/SModal/SModalPortalTo.vue'
export default {
  name: 'SduiContentMoveDecline',
  components: { SModalPortalTo },
  props: {
    isChannelOfCurrentSchoolYear: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['decline-content-move', 'close'],
}
</script>
